import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

export const RecordingIcon: React.FC = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
	>
		<circle cx="12" cy="12" r="6.25" />
		<path d="M12 1.5a10.5 10.5 0 1 0 10.5 10.5A10.512 10.512 0 0 0 12 1.5Zm0 19A8.5 8.5 0 1 1 20.5 12 8.51 8.51 0 0 1 12 20.5Z" />
	</svg>
)

const recPulse = keyframes`
	0%, 100% { fill: white; color: white; }
	50% { fill: #e53935; color: #e53935; }
`

const AnimatedSvg = styled.svg`
	animation: ${recPulse} 1.6s ease-in-out infinite;
`

export const RecordingActiveIcon: React.FC = () => (
	<AnimatedSvg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		viewBox="0 0 24 24"
	>
		<circle cx="12" cy="12" r="6.25" />
		<path d="M12 1.5a10.5 10.5 0 1 0 10.5 10.5A10.512 10.512 0 0 0 12 1.5Zm0 19A8.5 8.5 0 1 1 20.5 12 8.51 8.51 0 0 1 12 20.5Z" />
	</AnimatedSvg>
)
